import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/reducers';
import { FsmSubscriptionDetailResponse, SubscriptionPlan } from './fsmSubscription.model';

interface FsmSubscriptionPlansState {
  subscriptionPlans: SubscriptionPlan[];
  subscriptionDetails: FsmSubscriptionDetailResponse | null;
  isLoading: boolean;
  isLoadingDetails: boolean;
  error: string | null;
}

const initialState: FsmSubscriptionPlansState = {
  subscriptionPlans: [],
  subscriptionDetails: null,
  isLoading: false,
  isLoadingDetails: false,
  error: null
};

export const fsmSubscriptionPlansSlice = createSlice({
  name: 'fsmSubscriptionPlans',
  initialState,
  reducers: {
    setSubscriptionPlans: (state, { payload }: PayloadAction<SubscriptionPlan[]>) => {
      state.subscriptionPlans = payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setSubscriptionDetails: (state, { payload }: PayloadAction<FsmSubscriptionDetailResponse | null>) => {
      state.subscriptionDetails = payload;
      state.isLoadingDetails = false;
      state.error = null;
    },
    setLoadingDetails: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoadingDetails = payload;
    },
    resetSubscriptionPlans: () => initialState
  }
});

export const { setSubscriptionPlans, setLoading, setSubscriptionDetails, setLoadingDetails, resetSubscriptionPlans } =
  fsmSubscriptionPlansSlice.actions;

export const selectSubscriptionPlans = (state: RootState) => state.rootReducer.fsmSubscriptionPlans.subscriptionPlans;
export const selectSubscriptionPlansLoading = (state: RootState) => state.rootReducer.fsmSubscriptionPlans.isLoading;
export const selectSubscriptionPlansError = (state: RootState) => state.rootReducer.fsmSubscriptionPlans.error;
export const selectSubscriptionDetails = (state: RootState) =>
  state.rootReducer.fsmSubscriptionPlans.subscriptionDetails;
export const selectSubscriptionDetailsLoading = (state: RootState) =>
  state.rootReducer.fsmSubscriptionPlans.isLoadingDetails;

export default fsmSubscriptionPlansSlice.reducer;
